export namespace ProjectModel {
  export enum ClosureReason {
    WIN = 'WIN',
    LOSS = 'LOSS',
  }

  export enum ListTab {
    My = 'my',
    Shared = 'shared',
    Closed = 'closed',
  }

  export enum DateFilter {
    All = 'all',
    Last7 = 'last7',
    Last30 = 'last30',
    Last90 = 'last90',
    Custom = 'custom',
  }

  export enum MeasurementUnit {
    Imperial = 'Imperial',
    Metric = 'Metric',
  }

  export const PAGE_LIMIT = 100;

  export interface ProjectDocument {
    _id: string;
    orgId: string;
    createdAt: number;
    updatedAt: number;
    sharedWithMe?: boolean;
    createdByName?: string;
    name: string;
    totalPrice: number;
    measurementUnit: MeasurementUnit;
    closed: boolean;
    notes?: string;
    closureReason?: ClosureReason;
    closureNotes?: string;
  }

  export interface ListFilters {
    query: string;
    dateFilter: DateFilter;
    dateFrom: number | null;
    dateTo: number | null;
    closureReason: ClosureReason | '';
  }

  export namespace API {
    export interface ListProjectsQuery {
      query?: string;
      dateFrom?: number;
      dateTo?: number;
      closureReason?: ClosureReason;
    }

    export interface CreateProjectDto {
      name: string;
      measurementUnit: MeasurementUnit;
      notes?: string;
    }

    export type UpdateProjectDto = CreateProjectDto;

    export interface CloseProjectDto {
      closureReason: ClosureReason;
      closureNotes?: string;
    }
  }

  export namespace Dialog {
    export interface CreateProjectData {
      projectId?: string;
    }

    export interface CreateProjectResult {
      action: 'created' | 'updated' | 'deleted' | 'cancelled';
      projectId?: string;
    }

    export interface CloseProjectData {
      projectId: string;
    }

    export interface CloseProjectResult {
      action: 'closed' | 'cancelled';
    }
  }

  export function matchesRequestFilters(
    project: ProjectDocument,
    filters: API.ListProjectsQuery | null | undefined,
  ): boolean {
    if (!filters) {
      return true;
    }

    const query = filters.query?.trim().toLowerCase();

    if (query && !project.name.toLowerCase().includes(query)) {
      return false;
    }

    if (
      filters.closureReason &&
      project.closureReason !== filters.closureReason
    ) {
      return false;
    }

    if (
      filters.dateFrom !== undefined &&
      project.createdAt < filters.dateFrom
    ) {
      return false;
    }

    if (filters.dateTo !== undefined && project.createdAt > filters.dateTo) {
      return false;
    }

    return true;
  }
}
